// The dashboard filter bar for this browser session (item 4, decision 2b).
//
// `bar` is { userId, bar } - tagged with the user it belongs to, so signing in as someone else
// without a reload does not inherit the previous user's filters. `savedView` is the caller's
// saved view as v1/dashboardSavedView returns it ({ saved: false } when there is none), or
// null until it has been fetched this session.
export default {
  namespaced: true,
  state: {
    bar: null,
    savedView: null
  },
  mutations: {
    SET_BAR(state, value) {
      state.bar = value
    },
    SET_SAVED_VIEW(state, value) {
      state.savedView = value
    }
  },
  actions: {
    setBar({ commit }, value) {
      commit('SET_BAR', value)
    },
    setSavedView({ commit }, value) {
      commit('SET_SAVED_VIEW', value)
    }
  },
  getters: {
    bar: state => state.bar,
    savedView: state => state.savedView
  }
}
